import React from 'react';
import { Reveal } from './Reveal';
export function FilterBand() {
  return <section className="relative w-full border-y border-white/[0.07] bg-ink-950 py-9 sm:py-14" data-id="element-42" data-mp="2uvibrtq9xh0a">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_600px_200px_at_50%_50%,rgba(201,162,74,0.07),transparent_70%)]" aria-hidden="true" data-id="element-43" data-mp="2zul5wj4pu2th" />
      <Reveal className="relative mx-auto max-w-3xl px-5 text-center sm:px-6" data-id="element-44" data-mp="38v9iraidhx4s">
        <p className="text-balance text-[15px] leading-relaxed text-[#c7c3bb] sm:text-lg" data-id="element-45" data-mp="38t6vgy8lui3r">
          Si le gusta pagar un{' '}
          <span className="font-semibold text-gold-300" data-id="element-46" data-mp="3ilcli2faqpgb">600% de sobreprecio</span> por el mismo vial
          solo porque le ofrecen agua con infusión de pepino en la sala de espera,{' '}
          <span className="text-[#8b93a1]" data-id="element-47" data-mp="3nm0e2sj6becn">cierre esta página.</span>
        </p>
        <p className="mt-3.5 font-mono text-[10.5px] uppercase tracking-[0.16em] text-ash sm:mt-4 sm:text-[11px]" data-id="element-48" data-mp="3sh5ujbtt40tc">
          Esta guía es para quienes valoran su dinero tanto como su biología
        </p>
      </Reveal>
    </section>;
}